import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { add as addEvent } from 'bianco.events';

class Autologin extends PureComponent {
    static propTypes = {
        isUserAuthenticated: PropTypes.bool.isRequired,
        autologin: PropTypes.func.isRequired,
        fetchCart: PropTypes.func.isRequired,
    };

    componentDidMount() {
        addEvent(window, 'message', this.onMessage);
    }

    onMessage = (e) => {
        let payload;
        try {
            payload = JSON.parse(e.data);
        } catch (o_0) {
            return;
        }

        if (payload.dpdata) {
            this.props.fetchCart()
                .then(() => {
                    this.props.autologin({ user: payload.dpdata });
                });
        }
    };

    render() {
        const { isUserAuthenticated } = this.props;

        // no need to autologin if we were authenticated
        if (isUserAuthenticated) {
            return null;
        }

        return <iframe ref="root" hidden src='/autologin'/>;
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        isUserAuthenticated: 'user.isAuthenticated',
    }),
    reduxUtils.mapDispatchToProps({
        fetchCart: 'cart.fetchCart',
        autologin: 'user.autologin',
    }),
)(Autologin);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/autologin/index.js